import http from '@/utils/http';

export default {
	save: data => {
		return http({ url: '/api/admin/v1/menu/save', data, tip: true,loading:true }).then(r => r);
	},
	list: () => {
		return http({ url: '/api/admin/v1/menu/list' }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/menu/delete', data, tip: true,loading:true }).then(r => r);
	},
	topList: () => {
		return http({ url: '/api/admin/v1/menu/getTopList' }).then(r => r);
	},
	getAll: () => {
		return http({ url: '/api/admin/v1/menu/getAll' }).then(r => r);
	}
};